<div class="modal-backdrop" *ngIf="selectedPreviewUrl">
  <div class="modal-content">
    <iframe [src]="selectedPreviewUrl" type="application/pdf" width="700" height="500" ></iframe>

    <div class="d-flex w-100 justify-content-center align-items-center mt-2">
      <button class="btn btn-danger" (click)="closePreview()">Cerrar</button>
    </div>
  </div>
</div>
